
import { useNavigate } from "react-router-dom";
import { theme } from "../theme.js";
import Button from "./base/Button.jsx";
import Card from "./base/Card.jsx";
import { DEFAULT_IMAGE } from "../utils/constants.js";

export default function EventCard({ event = {}, orgId = null }) {
  // Get organizer name from event.organizer object or fallback
  const organizerName = event.organizer?.name || "Organizer";
  
  const id = event.id_bdd || event.id || Math.random();
  const title = event.name || "Untitled Event";
  const country = event.country || "";
  const location = event.location || "";
  const start = event.start_date
    ? new Date(event.start_date).toLocaleDateString()
    : "Date TBD";
  const end = event.end_date
    ? new Date(event.end_date).toLocaleDateString()
    : "Date TBD";

  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/events/${id}`, { state: { event, orgId } });
  };

  return (
    <Card id={id} onClick={handleCardClick}>
      <div style={styles.imageContainer}>
        <img src={event.image || DEFAULT_IMAGE} alt={title} style={styles.image} />
      </div>
      <div style={styles.cardContent}>
        <h3 style={styles.eventName}>{title}</h3>
        <p style={styles.location}>{location && country ? (`${location}, ${country}`) : location ? location : country ? country : "Location TBD"}</p>
        <p style={styles.distance}>{organizerName}</p>
        
        <div style={styles.datePrice}>
          <span style={styles.date}>{start + " - "+ end}</span>
          <span style={styles.time}>{event.races && event.races.length > 0 ? `${event.races.length} courses` : "Aucune course"}</span>
        </div>
        <div style={styles.footer}>
            <Button 
              onClick={handleCardClick}
              title="Voir les détails"
            />
        </div>
      </div>
    </Card>
  );
}

const styles = {
  imageContainer: {
    backgroundColor: theme.colors.bgLight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: `1px solid ${theme.colors.border}`,
    width: "100%",
    height: "220px",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  cardContent: {
    padding: theme.spacing.md,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    width: "100%",
    backgroundColor: theme.colors.bgLight,
  },
  eventName: {
    fontSize: theme.fonts.size.sm,
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.textInverted,
    margin: `0 0 ${theme.spacing.xs} 0`,
  },
  location: {
    fontSize: theme.fonts.size.xs,
    color: theme.colors.textMuted,
    margin: `0 0 ${theme.spacing.sm} 0`,
  },
  info: {
    display: "flex",
    gap: theme.spacing.xs,
    marginBottom: theme.spacing.sm,
  },
  distance: {
    fontSize: theme.fonts.size.xs,
    color: theme.colors.textInverted,
    marginBottom: theme.spacing.sm,
    fontWeight: theme.fonts.weight.medium,
  },
  datePrice: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xs,
    fontSize: theme.fonts.size.xs,
    color: theme.colors.textMuted,
    marginBottom: theme.spacing.sm,
  },
  date: {
    fontWeight: theme.fonts.weight.medium,
    color: theme.colors.textInverted,
    fontSize: theme.fonts.size.xs,
  },
  time: {
    color: theme.colors.textInverted,
    fontSize: theme.fonts.size.xs,
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "auto",
    paddingTop: theme.spacing.sm,
    borderTop: `1px solid ${theme.colors.border}`,
  },
  price: {
    fontSize: "20px",
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.textInverted,
  }
};